import React, { useContext, useDeferredValue } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetTaskCollection } from "widgets";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WidgetTaskCollectionContext } from "./WidgetTaskCollectionContext";
import { WidgetTaskCollectionPreviewQuery } from "./__generated__/WidgetTaskCollectionPreviewQuery.graphql";

type Props = {
  storecastId: string;
};

export function WidgetTaskCollectionPreview(props: Props) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => (
        <InnerWidgetTaskCollectionPreview {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWidgetTaskCollectionPreview(props: Props & { fetchKey: string }) {
  const context = useContext(WidgetTaskCollectionContext);
  const inputTasks = useDeferredValue(
    context.selectedTasks.map((t) => ({
      id: t.id,
      ordinal: t.ordinal,
      sectionId: t.sectionId,
    }))
  );
  const data = useLazyLoadQuery<WidgetTaskCollectionPreviewQuery>(
    graphql`
      query WidgetTaskCollectionPreviewQuery(
        $storecastId: ID!
        $input: PreviewWidgetTaskCollectionInput!
      ) {
        dashboard(id: $storecastId) @required(action: THROW) {
          previewWidgetTaskCollection(input: $input) {
            id
            ...WidgetTaskCollection_widgetTaskCollection
          }
        }
      }
    `,
    {
      input: {
        tasks: inputTasks,
        id: "WidgetAddTaskCollectionPreviewWidgetId",
      },
      storecastId: props.storecastId,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  return (
    <WidgetTaskCollection
      mode="IDLE"
      widget={data.dashboard.previewWidgetTaskCollection}
      storecastId=""
      interactive={false}
      clientTitle={context.title}
    />
  );
}
